"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORDERS = void 0;
var ORDERS = {
  TEXT__ORDER_NUMBER: 'orders-span-orderNumber',
  TEXT__ORDER_DATE: 'orders-span-orderDate',
  TEXT__DELIVERY_DATE: 'orders-span-deliveryDate',
  TEXT__STATUS: 'orders-span-status',
  TEXT__AMOUNT: 'orders-span-amount',
  TEXT__OUTLET_NAME: 'orders-span-outletName',
  TEXT__DISTRIBUTOR_NAME: 'orders-span-distributorName',
  ICON__INVOICE_PROCESSING_STATUS: 'orders-img-invoiceProcessingStatus'
};
exports.ORDERS = ORDERS;